import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { Text, Icon, Button, Layout } from '@ui-kitten/components'
import { FontAwesome5 } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'
import { useColors } from '../utils/useColors'
import { resolveBonusLevel } from '../utils/bonusLevel'

export const ClientView = React.memo(function ClientView({clientValue, clearClient, cashbackEnabled, punchCardEnabled, punchCardCapacity, bonusAction, setBonusAction, style, currencyFormatter, priceTypes = []}) {
  const { t } = useTranslation()
  const colors = useColors()

  const preferredPriceTypeName = React.useMemo(() => {
    if (!clientValue?.preferredPriceType) return null
    const priceType = priceTypes.find(pt => pt.id === clientValue.preferredPriceType)
    return priceType?.name
  }, [clientValue?.preferredPriceType, priceTypes])
  
  return (
    <Layout style={[styles.card, style]}>
      <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
        <View style={{flex: 1, marginRight: 10}}>
          <Text category='s2'>
            { clientValue.phoneNumber + ', ' + clientValue.displayName }
          </Text>
          { clientValue.address && (
            <Text category='c1' style={{marginTop: 2, color: colors.mediumGrey, fontSize: 12}}>
              {t('clients.address')}: {clientValue.address}
            </Text>
          )}
        </View>
        <TouchableOpacity onPress={() => {  
          clearClient()
        }}>
          <View>
            <Icon name='close-circle-outline' height={22} width={22} fill={colors.red} />
          </View>
        </TouchableOpacity>
      </View>
      { cashbackEnabled && (
        <View>
          <Text style={{marginTop: 5}}>
            {t('clients.bonusValue')}: {currencyFormatter.format(clientValue.bonusValue || 0)}
          </Text>
          <Text style={{marginTop: 5}}>
            {t('clients.bonusLevel')}: {resolveBonusLevel(clientValue)}%
          </Text>
        </View>
      )}
      { clientValue.loyaltyDiscount && (
        <Text style={{marginTop: 5}}>
          {t('clients.loyaltyDiscount')}: {clientValue.loyaltyDiscount.percentage == 0 ? t('none') : (clientValue.loyaltyDiscount.percentage ? clientValue.loyaltyDiscount.percentage + '%' : currencyFormatter.format(clientValue.loyaltyDiscount.amount || 0))}
        </Text>
      )}
      { preferredPriceTypeName && (
        <Text style={{marginTop: 5}}>
          {t('clients.preferredPriceType') || 'Preferred Price'}: {preferredPriceTypeName}
        </Text>
      )}
      { punchCardEnabled && (
        <View style={{flexDirection: 'row', marginTop: 5}}>
          <Text style={{marginRight: 5}}>
            {t('clients.punchCard')}:
          </Text>
          { [...Array(punchCardCapacity-1)].map((x, i) => (
            <FontAwesome5 key={i.toString()} name={clientValue.punchCardValue && clientValue.punchCardValue > i ? 'check-circle' : 'circle'} size={20} color='#8F9BB3'/>
          ))}
        </View>
      )}
      {bonusAction != null && cashbackEnabled && (<View style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: 10}}>
        <Button
          appearance='outline'
          status={bonusAction == 0 ? 'primary' : 'basic'}
          style={{width: '49%'}}
          onPress={() => {setBonusAction(0)}}
          testID="bonus-accumulate-button"
        >{t('accumulate')}</Button>
        <Button
          appearance='outline'
          status={bonusAction == 1 ? 'primary' : 'basic'}
          style={{width: '49%'}}
          onPress={() => {setBonusAction(1)}}
          testID="bonus-redeem-button"
        >{t('reduct')}</Button>
      </View>)}
    </Layout>
  )
}, function areEqual(prevProps, nextProps) {
  /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
  if (prevProps.bonusAction !== nextProps.bonusAction) {
    return false
  }
  if (prevProps.clientValue?.phoneNumber !== nextProps.clientValue?.phoneNumber) {
    return false
  }
  if (prevProps.clientValue?.displayName !== nextProps.clientValue?.displayName) {
    return false
  }
  if (prevProps.cashbackEnabled !== nextProps.cashbackEnabled) {
    return false
  }
  if (prevProps.punchCardEnabled !== nextProps.punchCardEnabled) {
    return false
  }
  if (prevProps.punchCardCapacity !== nextProps.punchCardCapacity) {
    return false
  }
  if (prevProps.clientValue?.loyaltyDiscount?.percentage !== nextProps.clientValue?.loyaltyDiscount?.percentage) {
    return false
  }
  if (prevProps.clientValue?.loyaltyDiscount?.amount !== nextProps.clientValue?.loyaltyDiscount?.amount) {
    return false
  }
  if (prevProps.clientValue?.address !== nextProps.clientValue?.address) {
    return false
  }
  if (prevProps.clientValue?.preferredPriceType !== nextProps.clientValue?.preferredPriceType) {
    return false
  }
  if (prevProps.priceTypes?.length !== nextProps.priceTypes?.length) {
    return false
  }
  return true
})

const styles = StyleSheet.create({
  card: {
    // flex: 1,
    borderRadius: 5,
    justifyContent: 'flex-start',
    padding: 10,
  },
})